module.exports = __webpack_public_path__ + "img/pitch_meeting.3a10b3c2.webp";